import Vue from 'vue';

/**
 * 生成一个用不重复的id
 * @param { Number } randomLength 
 */
 function getUniqueId(randomLength){
  return Number(Math.random().toString().substr(2,randomLength) + Date.now()).toString(36)
}

export default {
  install(Vue) {
    Vue.prototype.$getUniqueId = getUniqueId
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js